import { useDispatch, useSelector } from "react-redux";
import { setComponentToShow } from "@store/ModalToShow";
import { setIsForgotPassword } from "@store/login/loginStore";

export type LoginModalName =
  | "SendOtp"
  | "VerifyOtp"
  | "EditPhoneNumber"
  | "LoginWithPassword"
  | null;

export function useLoginModals() {
  const dispatch = useDispatch();
  const componentName = useSelector(
    (state: { modalToShow: { componentName: LoginModalName } }) =>
      state.modalToShow.componentName
  );

  const openModal = (name: LoginModalName) => {
    dispatch(setComponentToShow(name));
  };

  const closeModal = () => {
    dispatch(setIsForgotPassword(false));
    dispatch(setComponentToShow(null));
  };

  const goToSendOtp = () => openModal("SendOtp");
  const goToVerifyOtp = () => openModal("VerifyOtp");
  const goToEditPhone = () => openModal("EditPhoneNumber");
  const goToPasswordLogin = () => openModal("LoginWithPassword");
  const startForgotPassword = () => {
    dispatch(setIsForgotPassword(true));
    openModal("SendOtp");
  };

  return {
    activeModal: componentName,
    openModal,
    closeModal,
    goToSendOtp,
    goToVerifyOtp,
    goToEditPhone,
    goToPasswordLogin,
    startForgotPassword,
  };
}
